import script from "./ingredient-replacement-search.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredient-replacement-search.vue?vue&type=script&setup=true&lang=js"

import "./ingredient-replacement-search.vue?vue&type=style&index=0&id=15db700a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15db700a"]])

export default __exports__